import React from 'react'
import TermsOfService from '../terms-of-service'

const TermsOfServiceEn = () => {
    return <TermsOfService languageCode="en" />
}

export default TermsOfServiceEn
